import React from 'react'
import { Row, Col, Button } from 'antd'

import PermissionsChangeAll from './PermissionsChangeAll'
import PermissionsGrid from './PermissionsGrid'
import { Permission, Group } from './PermissionsTypes'

import I18n from '../../i18n';

type PropsType = {
  permissions: Array<Permission>,
  groups: Array<Group>,
  onChangePermission: any,
  onToggleModal: any,
  onToggleControls: any,
  loadPermissions: any,
  currentGroup: Group,
  loadingPermissions: boolean,
  permissionsLoaded: boolean,
  finalPermissions: any,
  onCreateInitialPermissionsObject: any,
  savePermissions: any,
  currentPermissions: any,
  getCurrentPermissionValue: any,
  onChangeAllPermissions: any,
  gridKey: any
}

class PermissionsControls extends React.Component<PropsType> {
  componentDidMount () {
    if (!this.props.permissionsLoaded) this.props.loadPermissions()
  }

  render() {
    const { permissions, groups, currentGroup, loadingPermissions, finalPermissions, gridKey } = this.props

    return (
      <div>
        <PermissionsChangeAll onChangeAllPermissions={this.props.onChangeAllPermissions} />

        <hr className="divider" />

        <Row type="flex" className="controls-panel">
          <Col className="max-height w-100">
            {loadingPermissions && <p>Loading permissions...</p>}
            {!loadingPermissions && <PermissionsGrid
              permissions={permissions}
              groups={groups}
              currentGroup={currentGroup}
              onChangePermission={this.props.onChangePermission}
              finalPermissions={finalPermissions}
              onCreateInitialPermissionsObject={this.props.onCreateInitialPermissionsObject}
              currentPermissions={this.props.currentPermissions}
              getCurrentPermissionValue={this.props.getCurrentPermissionValue}
              gridKey={gridKey}
            />}
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            <Button onClick={this.props.onToggleModal} type="link">
              {I18n.l('common.cancel')}
            </Button>

            <Button onClick={this.props.onToggleControls} className="ml-1" type="link">
              {I18n.l('common.back')}
            </Button>

            <Button type="primary" className="ml-1" shape="round" onClick={this.props.savePermissions}>
              {I18n.l('common.create')}
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default PermissionsControls